module.exports = __webpack_public_path__ + "img/bbl.74776c2b.png";